import { getAdobeAccessToken } from '../auth/adobeIms';

const DB_ACTION_BASE_URL = 'https://55338-856salmonanaconda-dev.adobeioruntime.net/api/v1/web/ondemand-tracker';

export interface UserRecord {
  email: string;
  name: string | null;
  accessLevel: AdobeImsAccessLevel;
}

function actionUrl(action: string): string {
  if (!DB_ACTION_BASE_URL) {
    throw new Error('Missing DB_ACTION_BASE_URL');
  }
  return `${DB_ACTION_BASE_URL.replace(/\/$/, '')}/${action}`;
}

export async function fetchUserRecord(userEmail: string): Promise<UserRecord | null> {
  try {
    const token = getAdobeAccessToken();
    const response = await fetch(actionUrl('db-get-user'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token || ''}`
      },
      body: JSON.stringify({ email: userEmail })
    });

    if (!response.ok) {
      return null;
    }

    const data = await response.json();
    if (!data?.found) {
      return null;
    }

    return data.user as UserRecord;
  } catch (error) {
    console.error('Error fetching user record:', error);
    return null;
  }
}
